<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">
                <h4 class="personal-details-title">Marketing Filter By User</h4>
                <div class="data-filter-block">
                    <div class="row">
                        <div class="col-md-5 col-lg-5">
                            <select name="" [(ngModel)]="userId" id="" class="form-control">
                                <option value="" selected disabled>-- select user --</option>
                                <option value="{{user.userId}}" *ngFor="let user of usersData">{{user.userName}} ({{user.userType}})</option>
                            </select>
                        </div>
                        <div class="col-md-5 col-lg-5">
                            <input type="date" [(ngModel)]="searchDate" class="form-control">
                        </div>
                        <div class="col-md-2 col-lg-2">
                            <button class="btn btn-primary" (click)="searchFilter()">Submit</button>
                        </div>
                    </div>
                </div>
                <table class="table table-striped">
                    <thead>
                        <tr>
                        <th scope="col">#</th>
                        <th scope="col">Name</th>
                        <th scope="col">Phone</th>
                        <th scope="col">Last Modified On</th>
                        <th scope="col">Status</th>
                        <th scope="col">Created On</th>
                        <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of marketingData | paginate : {
                            itemsPerPage: tableSize,
                            currentPage: page,
                            totalItems: count
                          } ;let i = index">
                        <th scope="col">{{i+1}}</th>
                        <th scope="col">{{data.name}}</th>
                        <th scope="col">{{data.phone}}</th>
                        <th scope="col">{{data.latestStatusDate|date : 'medium'}}</th>
                        <th scope="col">{{data.latestStatus}}</th>
                        <th scope="col">{{data.createdDate | date : 'medium'}}</th>

                        <th scope="col">
                            <span style="margin: 3px;">
                                <svg (click)="getMarketingDataById(data.marketingDataId)" data-toggle="modal" data-target="#updateModal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                    <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                                </svg>
                            </span>
                      
                            <span style="margin: 3px;">
                                <svg xmlns="http://www.w3.org/2000/svg" data-toggle="modal" data-target="#view" (click)="getMarketingDataById(data.marketingDataId)" width="18" height="18" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                                    <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                                </svg> 
                            </span>
                        </th>
                        </tr>
                    </tbody>
                </table>
                <div class="pagination-block" *ngIf="marketingData.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)">
                    </pagination-controls>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="view" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title status-b" id="exampleModalLabel">Marketing Data List  <span><button class="btn btn-primary" data-toggle="modal" data-target="#statusUpdatrPopup">{{latestStatus}}</button><i class="bi bi-x-square" data-dismiss="modal"></i></span> </h5>
            </div>
            <div class="modal-body">
                <div class="form-group" *ngFor="let data of singleMarketingData">
                    <div class="row">
                        <div class="col-md-6 col-lg-6">
                            <label>Name</label>
                            <input type="text" readonly value="{{data.name}}" class="form-control">
                        </div>
                        <div class="col-md-6 col-lg-6">
                            <label>Phone</label>
                            <input type="text" readonly value="{{data.phone}}" class="form-control">
                        </div>
                    
                        <div class="col-md-6 col-lg-6">
                            <label>Email</label>
                            <input type="text" readonly value="{{data.email}}" class="form-control">
                        </div>
                        <div class="col-md-6 col-lg-6" *ngFor="let keyValueList of data.keyValueList">
                            <label for="">{{keyValueList.key}}</label>
                            <input type="text" readonly value="{{keyValueList.value}}" class="form-control">
                        </div>
                    </div>
                    <!-- <div class="row update-status" *ngIf="toggleStatus" [formGroup]="updateMarketingForm">
                        <div class="col-md-12 col-lg-12">
                            <div class="form-group">
                              <select name="" id="" formControlName="status" class="form-control">
                                <option value="" disabled selected hidden>---Select Status---</option>
                                <option value="{{status.name}}" *ngFor="let status of statusList">{{status.name}}</option>
                              </select>
                            </div>
                          </div>
                        <div class="col-md-12 col-lg-12">
                            <textarea name="" id="" cols="30" rows="5" formControlName="note" class="form-control" placeholder="enter note"></textarea>
                        </div>
                        <div class="col-md-12 col-lg-12">
                            <button class="btn btn-secondary" (click)="updateStatus()">update status</button>
                        </div>
                    </div> -->
                    <div class="row key">
                        <div class="keys">
                            <div class="col-md-12 col-lg-12">
                                <div class="status-table">
                                    <table class="table">
                                        <thead>
                                          <tr>
                                              <th style="width: 10%;">User Id</th>
                                              <th style="width: 45%;text-align: center;">Note</th>
                                              <th style="width: 15%;text-align: center;">Status</th>
                                              <th style="width: 30%;text-align: center;">Modified</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr *ngFor="let status of data.marketingStatusList;">
                                              <td style="width: 10%;">{{status.userId}}</td>
                                              <td style="width: 45%;text-align: center;">{{status.note}}</td>
                                              <td style="width: 15%;text-align: center;">{{status.status}}</td>
                                              <td style="width: 30%;text-align: center;">{{status.statusDate | date : 'medium'}}</td>
                                          </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                     
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton2"  class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="updateModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title status-b" id="exampleModalLabel">Marketing Data Edit  <span><button class="btn btn-primary" data-toggle="modal" data-target="#statusUpdatrPopup" (click)="showStatus()">{{latestStatus}}</button><i class="bi bi-x-square" data-dismiss="modal"></i></span> </h5>
            </div>
            <div class="modal-body" style="padding-right: 0;">
                <div class="form-group" style="height: 480px;overflow-y: scroll;padding-right: 15px;overflow-x: hidden;" *ngFor="let data of singleMarketingData;let i = index">
                    <div class="row">
                        <div class="col-md-6 col-lg-6">
                            <label>Name</label>
                            <input type="text" [(ngModel)]="singleMarketingData[i].name" class="form-control">
                        </div>
                        <div class="col-md-6 col-lg-6">
                            <label>Phone</label>
                            <input type="text" [(ngModel)]="singleMarketingData[i].phone" class="form-control">
                        </div>
                    
                        <div class="col-md-6 col-lg-6">
                            <label>Email</label>
                            <input type="text" [(ngModel)]="singleMarketingData[i].email" class="form-control">
                        </div>
                        <div class="col-md-6 col-lg-6" *ngFor="let keyValueList of data.keyValueList;let j = index">
                            <label for="">{{keyValueList.key}}</label>
                            <input type="text" [(ngModel)]="singleMarketingData[i].keyValueList[j].value" class="form-control">
                        </div>
                    </div>
                    <!-- <div class="row update-status" *ngIf="toggleStatus" [formGroup]="updateMarketingStatus">
                        <div class="col-md-12 col-lg-12">
                            <div class="form-group">
                              <select name="" id="" formControlName="status" class="form-control">
                                <option value="" disabled selected hidden>---Select Status---</option>
                                <option value="{{status.name}}" *ngFor="let status of statusList">{{status.name}}</option>
                              </select>
                            </div>
                          </div>
                        <div class="col-md-12 col-lg-12">
                            <textarea name="" id="" cols="30" rows="5" formControlName="note" class="form-control" placeholder="enter note"></textarea>
                        </div>
                        <div class="col-md-12 col-lg-12">
                            <button class="btn btn-secondary" (click)="updateStatus()">update status</button>
                            <button class="btn btn-secondary" style="margin-left: 10px" (click)="updateStatusClose()">cancel</button>
                        </div>
                    </div> -->

                    <div class="row key">
                        <div class="keys">
                            <div class="col-md-12 col-lg-12">
                                <div class="status-table">
                                    <table class="table">
                                      <thead>
                                        <tr>
                                            <th style="width: 10%;">User Id</th>
                                            <th style="width: 45%;text-align: center;">Note</th>
                                            <th style="width: 15%;text-align: center;">Status</th>
                                            <th style="width: 30%;text-align: center;">Modified</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr *ngFor="let status of data.marketingStatusList;">
                                            <td style="width: 10%;">{{status.userId}}</td>
                                            <td style="width: 45%;text-align: center;">{{status.note}}</td>
                                            <td style="width: 15%;text-align: center;">{{status.status}}</td>
                                            <td style="width: 30%;text-align: center;">{{status.statusDate | date : 'medium'}}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                </div>
                            </div>

                     
                        </div>
                    </div>
                
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton2"  class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="button" (click)="updateMarketingData()" class="btn btn-primary">Update</button>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="statusUpdatrPopup" tabindex="-1" data-backdrop="static" aria-labelledby="statusUpdatrPopup" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Update Status</h5>
        </div>
        <div class="modal-body">
            <div class="row update-status" *ngIf="toggleStatus" [formGroup]="updateMarketingStatus">
                <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                      <select name="" id="" formControlName="status" class="form-control">
                        <option value="" disabled selected hidden>---Select Status---</option>
                        <option value="{{status.name}}" *ngFor="let status of statusList">{{status.name}}</option>
                      </select>
                    </div>
                  </div>
                <div class="col-md-12 col-lg-12">
                    <textarea name="" id="" cols="30" rows="5" formControlName="note" class="form-control" placeholder="enter note"></textarea>
                </div>
                <div class="col-md-12 col-lg-12">
                    <button class="btn btn-secondary" (click)="updateStatus()">update status</button>
                    <button class="btn btn-secondary" id="updateClose" data-dismiss="modal" style="margin-left: 10px" (click)="updateStatusClose()">cancel</button>
                </div>
            </div>
     
          <div class="modal-footer">
            <button type="button" id="closeModalButton67"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
</div>